<!-- https://github.com/David-Desmaisons/vue-plotly -->

<template>
  <div class="w-100">
    <Plotly
      v-if="typeof(getDataAoFConf)!=='undefined' && getDataAoFConf.length > 0"
      ref="plot"
      :data="getDataAoFConf"
      :layout="getLayoutAoFConf"
      :display-mode-bar="hoverPlotly"
      :displaylogo="false"
      :editable="true"
      @mouseover="hoverPlotly = true"
      @mouseleave="hoverPlotly = false"
      @relayout="plotReshaped"
      @click="clickGraph"
    />
    <div
      v-else
      class="d-flex justify-content-center h-100"
    >
      <b-spinner
        variant="primary"
        label="Loading"
      />
    </div>
    <b-container
      v-if="isSelectedAoFConf"
      id="selectedInfo"
      class="mt-2 area-container"
    >
      <b-row
        class="mt-2"
        align-v="center"
      >
        <b-col md="auto">
          <label
            for="selecIdValue"
            class="num-lbl-inpt mb-0"
          >Id: </label>
        </b-col>
        <b-col
          cols="3"
        >
          <b-form-input
            id="selecIdValue"
            v-model="selectedIdValue"
            type="text"
            class="num-inpt"
            size="sm"
            @blur="$emit('change')"
          />
        </b-col>
        <b-col md="auto">
          <label
            for="selecX1Value"
            class="num-lbl-inpt mb-0"
          >X1: </label>
        </b-col>
        <b-col
          cols="3"
        >
          <b-form-input
            id="selecX1Value"
            v-model="selectedX1Value"
            type="number"
            class="num-inpt"
            size="sm"
            @blur="$emit('change')"
          />
        </b-col>
        <b-col md="auto">
          <label
            for="selectX2"
            class="num-lbl-inpt mb-0"
          >X2: </label>
        </b-col>
        <b-col
          cols="3"
        >
          <b-form-input
            id="selectX2"
            v-model="selectedX2Value"
            type="number"
            class="num-inpt"
            size="sm"
            @blur="$emit('change')"
          />
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-button
          variant="outline-primary"
          class="mx-2 mt-0 mb-2"
          size="sm"
          @click="clickOK"
        >
          OK
        </b-button>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { Plotly } from 'vue-plotly'
import { mapGetters, mapActions } from 'vuex'
import defaultRectShape from '@/assets/configurationWindow/defaultRectShape.JSON'

/// Constants
const reShapeChange = /shapes\[(\d+)\]\.[yx][01]/g
// Limits to delete
const minDeleteY0 = -0.3
const maxDeleteY0 = 0.35
// Colors
const rectFillColor = '#d3d3d3' // It should be moved to Vuex, with a value of the original plot
const rectSelectedColor = '#66b2ff' // Color when the rectangle is selected
// Proportinal Size Main Container
const proportionalHeightOpened=0.65
const proportionalHeightClosed=0.87
const proportionalWidth=0.8

export default {
  name: 'InteractivePlotAoFConf',
  components: {
    Plotly
  },
  props:{
    showLegends:{
      type:Boolean,
      required: false,
      default:false
    },
  },
  data(){
    return{
      hoverPlotly:false,
    }
  },
  computed: {
    ...mapGetters(['getDataAoFConf', 'getLayoutAoFConf', 'getSelectedIdAxisAoFConf', 'getSelectedX1AxisAoFConf', 'getSelectedX2AxisAoFConf', 'getSelectedIndxAoFConf', 'isSelectedAoFConf','getWidthConfWindow','getHeigthConfWindow','getAreasAoFConf','getMinValueXAoFConf','getMaxValueXAoFConf']),
    // Properties used by the elements of the template
    selectedX1Value: {
      set (value) {
        this.setSelectedX1AxisAoFConf(value)
      },
      get () {
        return this.getSelectedX1AxisAoFConf
      }
    },
    selectedIdValue:{
      set (value) {
        this.setSelectedIdAxisAoFConf(value)
      },
      get () {
        return this.getSelectedIdAxisAoFConf
      }
    },
    selectedX2Value: {
      set (value) {
        this.setSelectedX2AxisAoFConf(value)
      },
      get () {
        return this.getSelectedX2AxisAoFConf
      }
    }
  },
  watch: {
    showLegends(){
      this.updateLegendsPlotly()
    },
    getDataAoFConf(){
      this.updateHeigth(this.getHeigthConfWindow)
      this.updateAreas()
    },
    getSelectedIndxAoFConf (newValue) {
      // When the index of the selected item changes, it changes the color to identify that element
      const extractedLayout = { shapes: this.getLayoutAoFConf.shapes }
      for (let i = 0; i < extractedLayout.shapes.length; i++) { // Cycle to restore the original color
        extractedLayout.shapes[i].fillcolor = rectFillColor
      }
      if (newValue >= 0 && newValue < extractedLayout.shapes.length) { // Verify that the index is in the limits
        extractedLayout.shapes[newValue].fillcolor = rectSelectedColor // update the color to the selected
        this.setSelectionFlagAoFConf(true)// Ensures that the selection flags is set
        this.setSelectedX1AxisAoFConf(extractedLayout.shapes[newValue].x0)// Updates the value of the selected X-axis imput
        this.setSelectedX2AxisAoFConf(extractedLayout.shapes[newValue].x1)// Updates the value of the selected X-axis imput
        this.$emit('change')
      }
      this.setShapesGraphAoFConf(extractedLayout.shapes)
      this.$refs.plot.relayout(extractedLayout)// Updates the Plotly Layout
    },
    isSelectedAoFConf (newValue) {
      if (!newValue) { // When it is nothing selected changes the indx to -1, it restores the color and prepares for the next change
        this.setSelectedIndxAoFConf(-1)
      }
      this.updateHeigth(this.getHeigthConfWindow)
    },
    getSelectedX1AxisAoFConf (newValue) {
      // Updates the position of the selected rectangle
      if (this.isSelectedAoFConf) { // When the value of the X-axis selected changes and it is something selected
        const extractedLayout = { shapes: this.getLayoutAoFConf.shapes }
        extractedLayout.shapes[this.getSelectedIndxAoFConf].x0 = newValue
        this.setShapesGraphAoFConf(extractedLayout.shapes)
        this.$refs.plot.relayout(extractedLayout)// Set the Plotly Layout
      }
    },
    getSelectedX2AxisAoFConf (newValue) {
      // Updates the position of the selected rectangle
      if (this.isSelectedAoFConf) { // When the value of the X-axis selected changes and it is something selected
        const extractedLayout = { shapes: this.getLayoutAoFConf.shapes }
        extractedLayout.shapes[this.getSelectedIndxAoFConf].x1 = newValue
        this.setShapesGraphAoFConf(extractedLayout.shapes)
        this.$refs.plot.relayout(extractedLayout)// Set the Plotly Layout
      }
    },
    getHeigthConfWindow(newValue){
      this.updateHeigth(newValue)
    },
    getWidthConfWindow(newValue){
      if(!('plot' in this.$refs) || typeof(this.$refs.plot)=='undefined'){
        return
      }
      const width= newValue*proportionalWidth
      const updatedLayout =
                {
                  width: width,
                  autosize: false
                }
      this.$refs.plot.relayout(updatedLayout)
      this.$refs.plot.relayout({ autosize: true })
    }
  },
  mounted() {
    this.updateHeigth(this.getHeigthConfWindow)
    this.updateAreas()
    this.updateLegendsPlotly()
  },
  methods: {
    // It is trigegred when the plotly graph is reshaped, it is more broad that what we require, so we need to filter the event
    plotReshaped(event) {
      const keysStr = Object.keys(event).join(',') // Join all the events key in a single string to execute the regex
      const rgxShapeChangeMatch = [...keysStr.matchAll(reShapeChange)] // Get all the matches with the shape arguments.

      if (rgxShapeChangeMatch.length === 4) { // Validate if it is a change in a rectangle. It is exactly four matches of the Regex. Otherwise it could be an action not performed by the user
        const indxShape = parseInt(rgxShapeChangeMatch[0][1]) // Get the index of the modified shape
        const extractedLayout = { shapes: this.getLayoutAoFConf.shapes } // Create an object with the Layout, it would be the only thing that would modify after

        // Delete condition. When Y0 is higher/lower than specific limit
        if (extractedLayout.shapes[indxShape].y0 < minDeleteY0 || extractedLayout.shapes[indxShape].y0 > maxDeleteY0) {
          extractedLayout.shapes.splice(indxShape, 1)// Remove from the layout
          this.deleteAreaAoFConf(indxShape)// remove from the area in Vuex
          if (this.isSelectedAoFConf && this.getSelectedIndxAoFConf === indxShape) { // If it was the current selected item
            this.setSelectionFlagAoFConf(false)
          }
        } else {
          // All the changes in the shape select the new value
          this.setSelectedIndxAoFConf(indxShape)
          const newXValues = [this.selectedIdValue, extractedLayout.shapes[indxShape].x0, extractedLayout.shapes[indxShape].x1 ]
          this.updateXAxisAoFConf({index:indxShape,newXVal:newXValues})

          // Update the X position if we move the selected rectangle
          if (this.isSelectedAoFConf && this.getSelectedIndxAoFConf === indxShape) {
            this.setSelectedX1AxisAoFConf(newXValues[1])
            this.setSelectedX2AxisAoFConf(newXValues[2])
          }

          // Verify that the y shape is correct
          extractedLayout.shapes[indxShape].y0 = 0
          extractedLayout.shapes[indxShape].y1 = 1
        }

        this.$emit('change')
        this.setShapesGraphAoFConf(extractedLayout.shapes)
        this.$refs.plot.relayout(extractedLayout) // Update the Plotly graph
      }
    },
    async clickGraph(event) { // Click on the plotly graph creates a new rectangle
      if (event.points.length > 0) { // It requires that there is some point of the graph to reference the X value
        const positionX1 = event.points[0].x // Use any X value, all are the same
        const positionX2 = await this.addAreaAoFConf({
          X1Value: positionX1,
          rangeXAxis: this.getMaxValueXAoFConf - this.getMinValueXAoFConf
        })// Add the new area to the Vuex State and return the X2 Value
        const extractedLayout = { shapes: this.getLayoutAoFConf.shapes }
        const newShape = JSON.parse(JSON.stringify(defaultRectShape)); //Deep copy of the base rect
        // Set the positions of the new rectangle
        newShape.y0 = 0
        newShape.y1 = 1
        newShape.x0 = positionX1
        newShape.x1 = positionX2


        const newShapeIndx = extractedLayout.shapes.length
        extractedLayout.shapes.push(newShape) // Add the rectangle to the layout
        this.setSelectedIndxAoFConf(newShapeIndx)// Set the new rectangle as the selected component

        this.setShapesGraphAoFConf(extractedLayout.shapes)
        this.$refs.plot.relayout(extractedLayout) // Update the Plotly layout
      }
    },
    clickOK() { // Event triggered when the button OK is clicked
      this.setSelectionFlagAoFConf(false) // When the button OK is clicked, there is no selected item.
    },
    updateHeigth(newValue){
      if(!('plot' in this.$refs) || typeof(this.$refs.plot)=='undefined'){
        return
      }

      let height = newValue;
      if(this.isSelectedAoFConf){
        height*=proportionalHeightOpened
      }
      else{
        height*=proportionalHeightClosed
      }
      const updatedLayout =
                {
                  height: height,
                  autosize: false
                }
      this.$refs.plot.relayout(updatedLayout)
      this.$refs.plot.relayout({ autosize: true })
    },
    updateAreas(){
      const extractedLayout = { shapes: [] }
      for(let j=0;j<this.getAreasAoFConf.length;j++){
        const newShape = JSON.parse(JSON.stringify(defaultRectShape)); //Deep copy of the base rect
        // Set the positions of the new rectangle
        newShape.y0 = 0
        newShape.y1 = 1
        newShape.x0 = this.getAreasAoFConf[j][1]
        newShape.x1 = this.getAreasAoFConf[j][2]
        if(this.isSelectedAoFConf && this.getSelectedIndxAoFConf === j){
          newShape.fillcolor = rectSelectedColor
        }

        extractedLayout.shapes.push(newShape) // Add the rectangle to the layout
      }
      this.setShapesGraphAoFConf(extractedLayout.shapes)
      this.$refs.plot.relayout(extractedLayout)
    },
    updateLegendsPlotly(){
      this.$refs.plot.relayout({showlegend:this.showLegends})
    },
    ...mapActions(['setLayoutPlot', 'setSelectedIdAxisAoFConf', 'setSelectedX1AxisAoFConf', 'setSelectedX2AxisAoFConf','setSelectedIndxAoFConf', 'setSelectionFlagAoFConf', 'addAreaAoFConf', 'deleteAreaAoFConf','setXValueConcAoFConf','updateXAxisAoFConf','setShapesGraphAoFConf'])
  },
}
</script>

<style scoped>
  .area-container{
    border: black solid 1.5px;
    background-color: #EEEEEE;
    font-size: 0.9rem;
  }
</style>
